import { Edit } from 'react-admin'
import Form from './form'
import { editOptions } from '../../util/component-options'
import { EmbeddedExtractionMappingsList } from '../../shared'

// Intention of update is to tweak the name, not to change the material.
// Disable Edit because Kimi is abusing it.

const MaterialsEdit = props => {
  return (
    <>
      <Edit {...editOptions} {...props} >
        <Form isUpdateDisabled />
      </Edit>
      <EmbeddedExtractionMappingsList
        resource='material_extraction_mappings'
        filter={{
          material_id_eq: props.id,
        }}
      />
    </>
  )
}

export default MaterialsEdit
